import type {PodRequestFn} from '../usePodRequest';
import type {OutlookPersonFromEmailJson} from './outlookPeopleFromEmailAddresses';

const OUTLOOK_ADD_IN_PERSON_AUTOCOMPLETE_PATH =
  '/outlook_add_in/person_autocomplete';

export type OutlookPersonAutocompleteJson = {
  people: OutlookPersonFromEmailJson[];
};

export const buildOutlookPersonAutocompletePath = (
  agencyId: number,
  options: {
    query?: string;
    recipientEmails?: readonly string[];
  } = {}
): string => {
  const params = new URLSearchParams();
  params.set('agency_id', String(agencyId));
  const query = options.query?.trim();
  if (query) {
    params.set('query', query);
  }
  for (const raw of options.recipientEmails ?? []) {
    const email = raw.trim();
    if (email) {
      params.append('recipient_emails[]', email);
    }
  }
  return `${OUTLOOK_ADD_IN_PERSON_AUTOCOMPLETE_PATH}?${params.toString()}`;
};

export const fetchOutlookPersonAutocomplete = async (
  request: PodRequestFn,
  agencyId: number,
  options: {
    query?: string;
    recipientEmails?: readonly string[];
  } = {}
): Promise<OutlookPersonAutocompleteJson> => {
  const path = buildOutlookPersonAutocompletePath(agencyId, options);
  const response = await request(path);
  const text = await response.text();
  if (!response.ok) {
    throw new Error(text || `Request failed (${response.status})`);
  }
  return JSON.parse(text) as OutlookPersonAutocompleteJson;
};
